import clsx from "clsx";
import RadioInput from "../RadioInput/RadioInput";

export type RadioType = {
  onChange: (selected: string | number | boolean) => void;
  selected: string | number | boolean;
  disabled?: boolean;
  options: Array<any>;
  layout?: "vertical" | "horizontal";
};

const RadioGroup: React.FC<RadioType> = ({
  disabled = false,
  options,
  layout = "horizontal",
  selected,
  onChange,
}) => {
  return (
    <div
      className={clsx([
        "flex",
        "gap-2",
        "w-full",
        {
          "pointer-events-none": disabled,
          "flex-col": layout === "vertical",
          "flex-row items-center": layout === "horizontal",
        },
      ])}
    >
      {options?.map?.(({ label, description, value }) => {
        return (
          <RadioInput
            label={label}
            description={description}
            selected={value === selected}
            value={value}
            key={value}
            onClick={() => onChange(value)}
          />
        );
      })}
    </div>
  );
};

export default RadioGroup;
